<template>
  <div class="reply-editor ltr:pl-3 ltr:pr-2 rtl:pr-3 rtl:pl-2">
    <div class="self-stretch w-0.5 bg-green-300" />
    <div class="flex-grow gap-1 mt-px text-xs truncate">
      <span class="text-xs font-semibold text-green-700">
        {{ senderName }}
      </span>
      <message-preview
        :message="message"
        :show-message-type="false"
        :default-empty-message="$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')"
        class="inline"
      />
    </div>
    <span
      v-tooltip="$t('CONVERSATION.REPLYBOX.DISMISS_REPLY')"
      class="material-symbols-outlined text-gray-500 text-base flex-shrink-0 cursor-pointer rounded-[4px] hover:bg-gray-300 w-4 h-4 flex items-center justify-center"
      @click.stop="$emit('dismiss')"
    >
      close
    </span>
  </div>
</template>

<script>
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';

export default {
  components: { MessagePreview },
  props: {
    message: {
      type: Object,
      required: true,
    },
    inbox: {
      type: Object,
      required: true,
    },
  },
  computed: {
    senderName() {
      return this.message?.sender?.name || this.inbox?.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.reply-editor {
  @apply bg-neutral-100 dark:bg-slate-800 rounded-[12px] py-1.5 tracking-wide;
  @apply flex items-center gap-2 border border-gray-200;
}
</style>
